import { api } from '../api-client';
import type { AuthResult, MeResult } from './types';

export interface RegisterInput {
  email: string;
  password: string;
  name: string;
  organisationName?: string;
  invitationToken?: string;
}

export const authApi = {
  login: (input: { email: string; password: string }) =>
    api.post<AuthResult>('/auth/login', input, { anonymous: true }),

  register: (input: RegisterInput) =>
    api.post<AuthResult>('/auth/register', input, { anonymous: true }),

  logout: () => api.post<{ ok: true }>('/auth/logout'),

  me: () => api.get<MeResult>('/auth/me'),

  forgotPassword: (input: { email: string }) =>
    api.post<{ ok: true }>('/auth/forgot-password', input, { anonymous: true }),

  resetPassword: (input: { token: string; password: string }) =>
    api.post<{ ok: true }>('/auth/reset-password', input, { anonymous: true }),

  verifyEmail: (input: { token: string }) =>
    api.post<{ ok: true }>('/auth/verify-email', input, { anonymous: true }),

  acceptInvitation: (token: string, input: { name?: string; password?: string }) =>
    api.post<AuthResult>(`/auth/invitations/${encodeURIComponent(token)}/accept`, input),
};
